import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ApiService } from '../services/api.service';

export class TranslationLoader implements TranslateLoader {
  constructor(private apiService: ApiService) {
  }

  getTranslation(language: string): Observable<any> {
    return this.apiService.getTranslation({ application: localStorage.getItem('domain'), language });
  }
}
